const en = {
  "common": {
    "querysearch": "Please enter the query criteria",
    "querybtn": "query"
  },
  "login": {
    "loginTitle": "ILIFI",
    "placeholderLoginName": "Please enter a user name",
    "placeholderpassword": "Please enter your password",
    "submitLogin": "Is the login...",
    "loginForm": "Login"
  },
  "home": {
    "editPasswd": "edit password",
    "exitLogin": "exit login"
  },
  "menutree": {

  },
  "userList": {
    "adduserBtn": "add user"
  }
}

export default en


// WEBPACK FOOTER //
// ./src/assets/languages/en.js